// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "chartkick/chart.js"
import "altcha"
import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()

// Hide Altcha widget after successful verification
document.addEventListener('DOMContentLoaded', () => {
  const setupAltcha = () => {
    const altcha = document.querySelector('altcha-widget');
    if (altcha) {
      altcha.addEventListener('statechange', (event) => {
        if (event.detail.state === 'verified') {
          event.target.style.display = 'none';
        }
      });
    }
  };

  setupAltcha();

  // Re-setup after Turbo navigation
  document.addEventListener('turbo:load', setupAltcha);
});
